import { clsx } from 'clsx';

export const CreateProjectHeadSteps = ({ step = 1 }) => {
  return (
    <>
      <div
        className={`h-[3px] w-10 bg-[linear-gradient(270deg,#96BFFF_0.51%,#9DA0FF_105.09%)]`}
      ></div>
      <div
        className={clsx(
          `h-[3px] w-10`,
          step >= 2
            ? 'bg-[linear-gradient(270deg,#98E3FC_0.49%,#96BFFF_98.71%)]'
            : 'bg-[#05050D33]',
        )}
      ></div>
      <div
        className={clsx(
          `h-[3px] w-10`,
          step >= 3 ? 'bg-[linear-gradient(90deg,#98E3FC_0%,#83F5DF_100%)]' : 'bg-[#05050D33]',
        )}
      ></div>
      <div
        className={clsx(
          `h-[3px] w-10`,
          step >= 4 ? 'bg-[linear-gradient(90deg,#83F5DF_0%,#9CFFC1_100%)]' : 'bg-[#05050D33]',
        )}
      ></div>
    </>
  );
};
